import React, { Component } from 'react';
import { Nav, Navbar, NavDropdown, Form, FormControl, Button, Carousel } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// import i18n from "../i18n";

export default function main() {
    return (
    <div>
        <Carousel>

            {/* <Carousel.Item>
                <LazyLoadImage
                    className="d-block w-100"
                    alt="First slide"
                    src="appDefault/1920x1080.webp?text=First slide&bg=373940"
                />
                <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
            </Carousel.Item> */}
            <Carousel.Item>
                <LazyLoadImage
                    className="d-block w-100"
                    alt="First slide"
                    src="appDefault/1920x1080.webp"
                />
                <Carousel.Caption>
                {/* <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
                <LazyLoadImage
                    className="d-block w-100"
                    alt="Second slide"
                    src="appDefault/1920x1080.webp"
                />
                <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
                <LazyLoadImage
                    className="d-block w-100"
                    alt="Third slide"
                    src="appDefault/1920x1080.webp"
                />
                <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
            </Carousel.Item>
            


        </Carousel>
    </div>
    );
}
  
    
  